import React from "react";
import { Box } from "@mui/system";
import Loader from "components/loader";
import ROUTE_NAMES from "routes/routeNames";
import { ReducersModal } from "utils/modals";
import { useNavigate } from "react-router-dom";
import CouponTable from "components/tables/couponTable";
import { useDispatch, useSelector } from "react-redux";
import { getCouponList } from "./action";

const Coupon = () => {
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const { limit, page, search, isLoading, category } = useSelector(
    (state: ReducersModal) => state.CouponReducer
  );

  React.useEffect(() => {
    dispatch(getCouponList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, search, category]);

  return (
    <Box>
      <CouponTable
        onAddPress={() => {
          navigate(ROUTE_NAMES.MAIN_ROUTES.CREATE_COUPON);
        }}
        onEditPress={(row) => {
          navigate(
            `${ROUTE_NAMES.MAIN_ROUTES.EDIT_COUPON}?couponId=${row._id}`,
            {
              state: {
                couponDetails: row,
              },
            }
          );
        }}
      />
      {isLoading && <Loader />}
    </Box>
  );
};

export default Coupon;
